import React from 'react';

const AvatarSetting = ()=>{

    return(<>아바타 설정 페이지</>);
}

export default AvatarSetting;